import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

const Challenge = () => {
  useEffect(() => {
    AOS.init({
      once: false,
      duration: 800,
      easing: 'ease-out'
    });
  }, []);

  return (
    <section className="lg:py-16 lg:px-12 px-4 py-12 bg-bgDefault text-white overflow-x-hidden">
      <div className="container mx-auto w-full max-w-full max-w-screen-xl overflow-hidden">
        {/* Header */}


        {/* Content Container */}
        <div className="lg:px-[168px]">
          {/* Description */}
          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8"
            data-aos="fade-down"
          >
            The Challenge
          </h2>

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            A leading psychiatric clinic was struggling with paper-based workflows that created significant barriers
            to quality mental healthcare delivery. Manual patient record management led to inconsistent documentation,
            lost session notes, and delayed prescription processing. The absence of teleconsultation capabilities limited
            patient access to care, particularly for those with mobility challenges or living in remote areas. Therapists
            spent more time on administrative tasks than patient care, and the clinic couldn't scale operations or maintain
            comprehensive treatment histories across multiple sessions and providers.
          </p>

          <h4
            className="text-xl font-semibold text-white mb-3"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            Key Challenges:
          </h4>
          <ul className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-8 lg:mb-12 list-disc pl-5 space-y-2">
            <li data-aos="fade-left" data-aos-delay="250">Paper-based patient records causing data loss, inconsistencies, and accessibility issues</li>
            <li data-aos="fade-left" data-aos-delay="300">No digital system for tracking therapy session notes across multiple appointments and providers</li>
            <li data-aos="fade-left" data-aos-delay="350">Manual prescription management leading to errors and delays in medication delivery</li>
            <li data-aos="fade-left" data-aos-delay="400">Lack of secure teleconsultation platform limiting patient access to mental healthcare</li>
            <li data-aos="fade-left" data-aos-delay="450">Inability to maintain comprehensive treatment histories and track patient progress over time</li>
            <li data-aos="fade-left" data-aos-delay="500">HIPAA compliance requirements for all patient data and communication channels</li>
            <li data-aos="fade-left" data-aos-delay="550">Need for intuitive interface for both clinicians and patients with varying tech literacy</li>
            <li data-aos="fade-left" data-aos-delay="600">Integration requirements with existing pharmacy systems and insurance providers</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Challenge
